export function truncateMiddle(
  value: string,
  maxLength = 60,
  ellipsis = "...",
  removeHttps = false
): string {
  if (typeof value !== "string") return "";
  if (value.length <= maxLength) return value;
  if (removeHttps) {
    // Remove "http://" or "https://"
    value = value.replace(/^https?:\/\//, "");
  }
  const ellipsisLength = ellipsis.length;
  if (maxLength <= ellipsisLength) {
    return value.slice(0, maxLength);
  }
  const remaining = maxLength - ellipsisLength;
  const headLength = Math.ceil(remaining / 2);
  const tailLength = Math.floor(remaining / 2);
  return `${value.slice(0, headLength)}${ellipsis}${value.slice(
    value.length - tailLength
  )}`;
}
